import { render, staticRenderFns } from "./vimeo.vue?vue&type=template&id=4f2bae02&scoped=true&"
import script from "./vimeo.vue?vue&type=script&lang=js&"
export * from "./vimeo.vue?vue&type=script&lang=js&"
import style0 from "./vimeo.vue?vue&type=style&index=0&id=4f2bae02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2bae02",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/gitlab-runner/builds/UejMkTXs/0/feng.chen/site-cms/site/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f2bae02')) {
      api.createRecord('4f2bae02', component.options)
    } else {
      api.reload('4f2bae02', component.options)
    }
    module.hot.accept("./vimeo.vue?vue&type=template&id=4f2bae02&scoped=true&", function () {
      api.rerender('4f2bae02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/global/videos/_components/vimeo.vue"
export default component.exports